export default __webpack_public_path__ + "static/media/2.0be6bd2f.jpg";